import { Cookies, getCookie } from './cookies';

export function getCustomerTrackingId(): string {
  const adobeIds = {
    au: getCookie(Cookies.ADOBE_AU),
    mc: getCookie(Cookies.ADOBE_MC),
    hb: getCookie(Cookies.ADOBE_HB),
  };
  if (adobeIds.au || adobeIds.mc || adobeIds.hb) {
    return `au:${adobeIds.au}||mc:${adobeIds.mc}||hb:${adobeIds.hb}`;
  }
  return '';
}
